<template>
  <div class="voattfooter">
    <p>Copyright © 2018 - Sport Motion s.r.o.</p>
    <p><a v-if="showStoreSwitch()" @click="setStore" href="">Zmenit store na {{invertedStore}}</a> | Made with<img src="../assets/heart.png">by&nbsp;<a
      href="https://www.voatt.cz/"
      target="_blank"
      rel="nofollow">Voatt</a></p>
  </div>
</template>

<script>
  export default {
    data: {
      STORE_HK: 24,
      STORE_PCE: 23
    },
    props: {},
    methods: {
      setStore() {
        $cookies.set('STORE_COOKIE', $cookies.isKey('STORE_COOKIE') && $cookies.get('STORE_COOKIE') === 'hk' ? 'pce' : 'hk');
      },
      showStoreSwitch() {
        return window.location.hostname === 'sup-vuejs.server2.voatt.cz';
      },
    },
    computed: {
      store() {
        return $cookies.isKey('STORE_COOKIE') && $cookies.get('STORE_COOKIE') === 'hk' ? 'HK' : 'PCE';
      },
      invertedStore() {
        return $cookies.isKey('STORE_COOKIE') && $cookies.get('STORE_COOKIE') === 'hk' ? 'PCE' : 'HK';
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue